import React from 'react';

import {runURL} from 'results/assays/AssayRecordDAO';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';
import {readableTime} from 'util/DateUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function AutomationOutputFileChip(
  props: SharedSmartChipProps<SmartChipType.AUTOMATION_OUTPUT_FILE>
): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: aof,
    handleClickLink,
    isInaccessible,
    itemUrl: runUrl,
  } = useSmartChipQuery<SmartChipType.AUTOMATION_OUTPUT_FILE>({
    id,
    onClick,
    // NOTE: getUrl requires a string, so return an empty string if run is missing, and check for empty string below.
    getUrlFn: (aof) => (aof.runId ? runURL(aof.runId) : ''),
  });

  let chipAof;
  if (aof != null) {
    chipAof = {
      ...aof,
      id: aof.id,
      name: `${aof.name} ${readableTime(aof.createdAt)}`,
    };
  }

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={aof != null ? apiIdToIconName(aof.id) : null}
      isInaccessible={isInaccessible}
      item={chipAof}
      onClick={handleClickLink}
      url={runUrl === '' ? null : runUrl}
    />
  );
}
